import { render } from "./third-party-login.vue?vue&type=template&id=12e5da78&scoped=true"
const script = {}

import "./third-party-login.vue?vue&type=style&index=0&id=12e5da78&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12e5da78"]])

export default __exports__